import React from 'react'
import { Table, Space, Button, Divider, Popconfirm } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

const Categories = (props) => {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: 'Action',
      key: 'action',
      lign: 'right',
      width: 200,
      render: (text, record) => (
        <Space size='small' split={<Divider type='vertical' />}>
          <Button size='small' type='link' onClick={() => props.updateCategory(record.id)}>
            Edit
          </Button>
          <Popconfirm
            title='Are you sure?'
            onConfirm={() => props.deleteCategory(record.id)}
            okText='Yes'
            cancelText='No'
          >
            <Button size='small' type='link' disabled={props.actionLoading}>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      )
    }
  ]

  return (
    <>
      <Table
        rowKey={(record) => record.id}
        size='small'
        pagination={false}
        columns={columns}
        dataSource={props.list}
        bordered
        sticky
        footer={() => (
          <Space align='end'>
            <Button
              onClick={props.createCategory}
              size='small'
              className='pull-right'
              type='link'
              icon={<PlusOutlined />}
            >
              Add category
            </Button>
          </Space>
        )}
      />
    </>
  )
}

Categories.defaultProps = {
  list: [],
  actionLoading: false,
  createCategory: async () => {},
  updateCategory: async (id) => {},
  deleteCategory: async (id) => {}
}

export default Categories
